<div class="row" [scAnchorTarget]="'Skills'" *ngIf="candidate">

  <!-- <div class="col-12 section-title">
    <h3 class="mb-5">{{ texts.title | localize }}</h3>
  </div> -->



  <div class="col-12">
    <div class="pretitle mb-4">{{ texts.title | localize }}</div>

    <p *ngIf="!candidate.Skills?.length && !candidate.TopSkills?.length">
      {{ texts.noInformation | localize }}
    </p>

    <ul class="tag-list list-inline mb-0">
      <li class="list-inline-item" *ngFor="let tag of candidate.TopSkills">
        <span class="tag tag-clip-text tag-light border-success">
          <i class="fa-sharp fa-solid fa-badge-check text-success me-1"></i> {{tag}}
        </span>
      </li>
      <li class="list-inline-item" *ngFor="let tag of candidate.Skills"><span
          class="tag tag-clip-text tag-light">{{tag}}</span></li>
    </ul>


  </div>
</div>